<div class="form-dialog">
  <mat-dialog-content class="export-dialog">
    <div>
      @if (action == 'Add') {
        <mat-form-field>
          <mat-label>Select export type</mat-label>
          <mat-select [(value)]="exportConfig.export_type" (selectionChange)="onExportTypeSelected($event)">
            @for (type of supportedExporterTypes; track type) {
              <mat-option [value]="type">
                {{type}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (action == 'Add') {
        <mat-form-field>
          <mat-label>Select additional exporter option (if required)</mat-label>
          <mat-select [(value)]="exportConfig.export_name">
            @for (handler of supportedExportHandlers; track handler) {
              <mat-option [value]="handler">
                {{handler}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field>
        <mat-label>Display text</mat-label>
        <input matInput placeholder="Display text" [(ngModel)]="exportConfig.display_text">
      </mat-form-field>
      <mat-checkbox [(ngModel)]="exportConfig.supports_row_export" [checked]="exportConfig.supports_row_export">Supports
        exporting per row
      </mat-checkbox>
      <mat-checkbox (change)="onChangeBulkExport($event);" [checked]="exportConfig.supports_bulk_export">Supports
        exporting in bulk
      </mat-checkbox>

    </div>
    <ng-template #elseTemplate>
      Are you sure you want to delete <b>{{exportConfig.name}}</b>?
    </ng-template>
  </mat-dialog-content>

  <div class="action-buttons">
    <button class="btn-close" (click)="closeDialog()">Cancel</button>
    <button class="btn-save" (click)="doAction()">Save</button>
  </div>
</div>
